import { Button, ButtonProps, useMediaQuery, useTheme, Theme } from '@mui/material'
import { withStyles } from '@mui/styles'
import React from 'react'

interface IProps extends Omit<ButtonProps, 'children'> {
  href?: string
  endIcon?: JSX.Element
  target?: string
}

const RoundedButton: React.FC<IProps> = (props) => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('xs'))
  const StyledButton = withStyles((theme: Theme) => ({
    root: {
      display: 'flex',
      justifyContent: 'center',
      fontSize: '20px',
      borderRadius: '50px',
      textTransform: 'inherit',
      marginBottom: '15px',
      color: theme.palette.common.white,
      backgroundColor: theme.palette.secondary.main,
      '&:hover': {
        color: theme.palette.secondary.main,
        backgroundColor: theme.palette.common.white,
        '& svg path': {
          fill: theme.palette.secondary.main,
        },
      },
      padding: '12px 30px',
      width: isMobile ? '280px' : '300px',
      '& .MuiSvgIcon-root': {
        fontSize: '30px',
      },
      '& .MuiButton-label': {
        width: !props.endIcon ? 'auto' : '100%',
        margin: !props.endIcon ? '0 auto' : '',
      },
    },
  }))(Button)

  return <StyledButton
    href={props.href}
    endIcon={props.endIcon}
    target={props.target}
    {...props}
  ><div>{props.children}</div></StyledButton>
}

export default RoundedButton
